import { proporcao } from '../faixas'
import { moeda } from '../formato'
import { usarNumeroAnimado } from '../ganchos/usarNumeroAnimado'
import { Velocimetro } from './Velocimetro'

/**
 * A faixa do número herói — porte direto de `<section class="geral">` do
 * protótipo.
 *
 * **Fica na tela em todas as visões**, como o cabeçalho: o número do topo nunca
 * sai da tela, e é o ÚNICO número herói do painel (dois números gigantes
 * competindo fazem a vista não saber onde pousar).
 *
 * Tudo em reais, e no número CHEIO: `R$ 83.460.000 / R$ 100.000.000`. Não há
 * percentual na tela — a proporção só posiciona a agulha e escolhe a cor da
 * faixa. Também não existe o texto "de R$ X": a meta é o segundo termo do par.
 *
 * O véu `.geral::before` depende do `position: relative` do `.geral`, que já
 * está no CSS. Sem ele o degradê se ancora na viewport e escurece a tela
 * inteira — já aconteceu.
 */

type Props = {
  /**
   * `null` é "ninguém mediu nada ainda", diferente de `0`. O contrato
   * (`api.ts`) devolve `vendidoTotal: number | null`, e a tela respeita a
   * diferença.
   */
  vendidoTotal: number | null
  metaGeral: number
}

export function FaixaGeral({ vendidoTotal, metaGeral }: Props) {
  /* O número SOBE até o valor novo em vez de saltar (13/10). A animação
     devolve `null` enquanto nada foi medido, e aí a tela segue em `R$ —`. */
  const subindo = usarNumeroAnimado(vendidoTotal)
  /* `R$ —`, nunca `R$ 0`: zero no telão de uma War Room é uma pergunta na sala. */
  const vendido = subindo === null ? 'R$ —' : moeda(subindo)

  /* Nada medido deixa a agulha no início da escala — não há valor para
     posicioná-la, e `proporcao` já devolve 0 para meta ausente ou zerada. */
  const proporcaoGeral = proporcao(vendidoTotal ?? 0, metaGeral)

  return (
    <section className="geral">
      <div className="geral-numeros">
        <div className="rotulo-geral">Meta Vendas</div>
        {/* O `.par-vendido` mantém o vendido e a barra juntos: no celular o par
            quebra em duas linhas levando a barra consigo, em vez de encolher a
            fonte a ponto de não se ler nem de perto. */}
        <div className="valor-geral">
          <span className="par-vendido">
            <span>{vendido}</span> <span className="barra-meta">/</span>
          </span>
          <span className="meta">{moeda(metaGeral)}</span>
        </div>
      </div>

      <div className="bloco-velocimetro">
        <Velocimetro proporcao={proporcaoGeral} classe="vel-geral" />
      </div>
    </section>
  )
}
